/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/**
 * i18n Configuration
 * Supports French (default), English, and Arabic (RTL)
 */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translation files
import ar from './locales/ar.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

// Language configuration
export const languages = {
  fr: { name: 'Français', dir: 'ltr', flag: '🇫🇷' },
  en: { name: 'English', dir: 'ltr', flag: '🇬🇧' },
  ar: { name: 'العربية', dir: 'rtl', flag: '🇸🇦' },
} as const;

export type LanguageCode = keyof typeof languages;
export type SupportedLanguage = LanguageCode;

// Supported languages array
export const SUPPORTED_LANGUAGES = Object.keys(languages) as SupportedLanguage[];

// Default language
export const defaultLanguage: LanguageCode = 'fr';

// Initialize i18next
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: defaultLanguage,
    supportedLngs: Object.keys(languages),
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'bnft-language',
    },
  });

// Helper to reduce a detected language ("fr-FR", "en-US"...) to a supported code
export const getBaseLanguage = (lang?: string): LanguageCode => {
  const code = (lang || defaultLanguage).split('-')[0];
  return code in languages ? (code as LanguageCode) : defaultLanguage;
};

// Helper to get direction from language
export const getDirection = (lang: string): 'ltr' | 'rtl' => {
  return languages[lang as LanguageCode]?.dir || 'ltr';
};

// Helper to check if language is RTL
export const isRTL = (lang: string): boolean => {
  return getDirection(lang) === 'rtl';
};

export default i18n;
